import { useEffect, useState } from 'react';

const FREEZE_CLASS = 'modal-open';

/**
 * Убирает скрол у заднего фона (полезно для реализации модальны окон)
 * Добавляет класс modal-open к body
 *
 * @param defaultValue - начальное значение для заморозки
 */
const useFreezeBody = (defaultValue = false) => {
  const [isFreeze, setIsFreeze] = useState<boolean>(defaultValue);

  useEffect(() => {
    if (isFreeze) {
      document.body.classList.add(FREEZE_CLASS);
      document.documentElement.classList.add(FREEZE_CLASS);
    } else {
      document.body.classList.remove(FREEZE_CLASS);
      document.documentElement.classList.remove(FREEZE_CLASS);
    }
    return () => {
      document.body.classList.remove(FREEZE_CLASS);
      document.documentElement.classList.remove(FREEZE_CLASS);
    };
  }, [isFreeze]);

  return {
    isFreeze,
    setIsFreeze,
  };
};

export default useFreezeBody;
